var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-card-wrapper"},[_c('div',{staticClass:"title"},[_vm._t("title",function(){return [_c('rd-text',{staticClass:"font-h4-medium",attrs:{"textType":"title","bigger":true}},[_vm._v(_vm._s(_vm.title))])]})],2),_c('div',{staticClass:"content font-h4-regular"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }